export enum PageType {
    Home = 1,
    Pins = 2,
    Search = 3
}